import axios from 'axios';

const client = axios.create({
    baseURL: '/api/bbr',
    withCredentials: true,
});

function unwrap(promise) {
    return promise
        .then((response) => response.data)
        .catch((error) => {
            const message = (error.response && error.response.data && error.response.data.error)
                || error.message
                || 'Request failed';
            throw new Error(message);
        });
}

export function listSuites() {
    return unwrap(client.get('/suites'));
}

export function getSuite(id) {
    return unwrap(client.get(`/suites/${id}`));
}

export function getSuiteDoc(suiteId, docId) {
    return unwrap(client.get(`/suites/${suiteId}/docs/${docId}`));
}

export function listRunsForDoc(docId) {
    return unwrap(client.get(`/docs/${docId}/runs`));
}

export function startSuite(body) {
    return unwrap(client.post('/suites', body));
}

export function cancelSuite(id) {
    return unwrap(client.post(`/suites/${id}/cancel`));
}

export function deleteSuite(id) {
    return unwrap(client.delete(`/suites/${id}`));
}

export function compareSuites(from, to) {
    return unwrap(client.get('/suites/compare', { params: { from, to } }));
}

export function listCorpora() {
    return unwrap(client.get('/corpora'));
}

export function getCorpus(id) {
    return unwrap(client.get(`/corpora/${id}`));
}

export function createCorpus(body) {
    const payload = typeof body === 'string' ? { name: body } : body;
    return unwrap(client.post('/corpora', payload));
}

export function updateCorpus(id, body) {
    return unwrap(client.patch(`/corpora/${id}`, body));
}

export function addCorpusMail(id, body) {
    return unwrap(client.post(`/corpora/${id}/mails`, body));
}

export function updateCorpusMail(id, docId, body) {
    return unwrap(client.patch(`/corpora/${id}/mails/${docId}`, body));
}

export function removeCorpusMail(id, docId) {
    return unwrap(client.delete(`/corpora/${id}/mails/${docId}`));
}

export function listCoverageMetrics() {
    return unwrap(client.get('/coverage/metrics'));
}

export function proposeCorpusComposition(body) {
    return unwrap(client.post('/coverage/proposals', body));
}

export function applyCorpusComposition(id, body) {
    return unwrap(client.post(`/corpora/${id}/composition`, body));
}

export function createCorpusFromComposition(body) {
    return unwrap(client.post('/corpora/from-composition', body));
}

export function listModels(type) {
    return unwrap(client.get('/models', { params: { type } }));
}



// WEBPACK FOOTER //
// ./app/services/testRuns.js